/* ============================================================
   RIZZO ATELIER — Müşteri sesleri bölümü, sekme filtresi
   Dosya: assets/rizzo-voices.js
   ============================================================ */

(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.rzVoicesReady === 'true') return;
    root.dataset.rzVoicesReady = 'true';

    var tabs = root.querySelectorAll('.rz-voices__tab');
    var cards = root.querySelectorAll('.rz-voices__card');
    if (!tabs.length || !cards.length) return;

    function select(value) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.rzTab === value;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        card.classList.toggle('is-hidden', card.dataset.rzPanel !== value);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab.dataset.rzTab);
      });

      // Sol/sağ ok tuşlarıyla sekmeler arasında gezinme
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        var next = event.key === 'ArrowRight' ? i + 1 : i - 1;
        if (next < 0) next = list.length - 1;
        if (next >= list.length) next = 0;
        list[next].focus();
        select(list[next].dataset.rzTab);
        event.preventDefault();
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.rz-voices').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
